import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  lastConditionalSelectionBuy: '',  
  buyStrategy: '',  
  isExpressionBuyCorrect: false,
  buySelectedItems:'',
  canDelete:false,
  buyExpressionValidation:'',
  selectedStrategy:null,
  editMode:false,
  selectedRowIndex:null,
  errorMsg:null,
  buyConditions: [
    { operand1: null, operator: null, operand2: null, conditional: null, enabled: true, operand2Options: [] }
  ]
};

const buyStrategySettingsSlice = createSlice({
  name: 'buyStrategySettings',
  initialState,
  reducers: {
    setLastConditionalSelectionBuy: (state, action) => {
      state.lastConditionalSelectionBuy = action.payload;
    },
    setBuyStrategy: (state, action) => {
      state.buyStrategy = action.payload;
    },    
    setIsExpressionBuyCorrect: (state, action) => {
      state.isExpressionBuyCorrect = action.payload;
    },    
    setBuySelectedItems: (state, action) => {
      state.buySelectedItems = action.payload;
    },    
    setCanDelete: (state, action) => {
      state.canDelete = action.payload;
    },    
    setBuyExpressionValidation: (state, action) => {
      state.buyExpressionValidation = action.payload;
    },    
    setSelectedStrategy: (state, action) => {
      state.selectedStrategy = action.payload;
    },    
    setEditMode: (state, action) => {
      state.editMode = action.payload;
    },    
    setSelectedRowIndex: (state, action) => {
      state.selectedRowIndex = action.payload;
    },    
    setErrorMsg: (state, action) => {
      state.errorMsg = action.payload;
    },    
    setBuyConditions: (state, action) => {
      if (Array.isArray(action.payload)) {
        state.buyConditions = action.payload;
      } else if (action.payload.index !== undefined && action.payload.field && action.payload.value !== undefined) {
        const { index, field, value } = action.payload;
        if (state.buyConditions[index]) {
          state.buyConditions[index] = { ...state.buyConditions[index], [field]: value };
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase('reset', () => initialState);
  }
});

export const {
  setLastConditionalSelectionBuy,
  setBuyStrategy,  
  setCanDelete,
  setIsExpressionBuyCorrect,  
  setBuyConditions, setBuySelectedItems, setBuyExpressionValidation, 
  setSelectedStrategy, setEditMode, setSelectedRowIndex, setErrorMsg
} = buyStrategySettingsSlice.actions;
export default buyStrategySettingsSlice.reducer;